<template>
    <div>
        <table class="table table-striped">
            <thead>
            <tr>
                <th>Beschreibung</th>
                <th>Typ</th>
                <th>Bild</th>
                <th>Version</th>
                <th class="text-right">Actions</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="result in data.results">
                <td>{{result.name.text}}</td>
                <td>{{result.class}}</td>
                <td>{{(result.image && result.image.urls) ? 'Ja' : 'Nein'}}</td>
                <td>{{result.editVersion}}</td>
                <td class="text-right">
                    <a v-if="result.file && result.file.url" :href="result.file.url" target="_blank"><i class="fa fa-file fa-fw"></i></a>
                    <a href="#" v-confirm="{
                            html: true,
                            ok: dialog => remove(dialog, result),
                            message: 'Bist du sicher, dass du das Resultat <strong>'+result.name.text+'</strong> löschen möchtest?'}"><i
                            class="fa fa-trash fa-fw"></i></a>
                    <router-link :to="{ name: linkName, params: { resultId: result.id }}"><i
                            class="fa fa-edit fa-fw"></i></router-link>
                </td>
            </tr>
            </tbody>
        </table>
        <hr>
        <a href="#" class="btn btn-success" style="margin-top: auto;"
           @click.prevent="showCreateModal = true">Hinzufügen</a>

        <b-modal ref="modal" v-model="showCreateModal" @ok="add">
            <h1 slot="modal-title">Result hinzufügen</h1>
            <div class="form-group">
                <label for="name">Name</label>
                <input type="text" id="name" v-model="newResultName" class="form-control">
            </div>
            <div class="form-group">
                <label for="name">Typ</label>
                <select type="text" id="type" v-model="newResultType" class="form-control">
                    <option value="BroadcastResult">Broadcast</option>
                    <option value="FilmResult">Film</option>
                    <option value="MediaReleaseResult">Media Release</option>
                    <option value="NewspaperArticleResult">Zeitungsartikel</option>
                    <option value="NonScientificPublicationResult">Non-Scientific Publication</option>
                    <option value="PosterResult">Poster</option>
                    <option value="PresentationResult">Präsentation</option>
                    <option value="ScientificPublicationResult">Scientific Publication</option>
                    <option value="WebProductResult">Web Product</option>
                </select>
            </div>
        </b-modal>

    </div>
</template>
<script>
export default {
  props: ["data", "entity"],
  data() {
    return {
      showCreateModal: false,
      project: this.data,
      newResultName: "",
      newResultType: "BroadcastResult"
    };
  },
  computed: {
    linkName() {
      return this.$route.name.slice(0, -1);
    }
  },
  methods: {
    remove(dialog, result) {
      axios
        .post(
          "/api/" + store.state.language + "/result/" + result.id + "/delete"
        )
        .then(({ data }) => {
          if (data.success) {
            this.project.results.splice(
              this.project.results.indexOf(result),
              1
            );
          }
        });
    },
    add() {
      let form = new FormData();
      form.append("create_result[name]", this.newResultName);
      form.append("create_result[type]", this.newResultType);
      store.commit("addSavingProcess");
      axios
        .post(
          "/api/" +
            store.state.language +
            "/" +
            this.entity +
            "/" +
            this.data.id +
            "/create_result",
          form
        )
        .then(({ data }) => {
          this.project.results.push(data.result);
          this.newResultName = "";
          this.newResultType = "BroadcastResult";
          store.commit("finishSavingProcess");
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/admin/result/List.vue